module.exports = __webpack_public_path__ + "static/media/google_icon.bc1306c2.png";